module.exports = __webpack_public_path__ + "media/binaryfrom.47a4361a.mp4";